/*
 * @Author: aalizzwell 
 * @Date: 2019-05-29 19:07:30 
 * @Last Modified by: aalizzwell
 * @Last Modified time: 2019-05-29 19:31:19
 */
import { Injectable } from '@angular/core';
import { BindingData } from '@farris/devkit';

/**
 * EntityListæå¡
 * @scope FrameComponent
 */
@Injectable()
class EntityListService {

  constructor(private bindingData: BindingData) {}

    /**
     * è·åå½åé¡µç 
     */
    public get pageIndex() {
        return this.bindingData.list.pageIndex;
    }

    /**
     * è·åå½ååé¡µå¤§å°
     */
    public get pageSize() {
        return this.bindingData.list.pageSize;
    }
}

export { EntityListService };
